module.exports = __webpack_public_path__ + "img/cuff_length.adf7a5d6.png";